import React from 'react';
import cx from 'classnames';
import styles from './sixSenseActivationView.module.scss';
import InputField from 'src/legacy/components/InputField';
import { localizedStrings } from 'src/localization/index.jsx';

class SixSenseActivationView extends React.Component {
  constructor(props){
    super(props);
    const integration = this.props.integration;

    this.state = {
      apiKey: integration && integration.configuration.apiKey || '',
      errors: {}
    }

    this._handleAuthenticationClick = this._handleAuthenticationClick.bind(this);
    this._handleCancelClick = this._handleCancelClick.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedCommons = localizedStrings.commons;
    this.localizedSixSense = localizedStrings.components.integrations.six_sense;
  }

  _handleFieldChange(field, e){
    let value =  e.target.value;
    this.setState({
      [field]: value
    });
  }

  _handleAuthenticationClick(source){
    let errors = this._validateForm();

    this.setState({
      errors: errors
    });

    if(Object.keys(errors).length > 0){      
      return;
    }
    let configuration = {
      apiKey : this.state.apiKey
    }
    this.props.activateAccount(configuration).then((response) => {
      if (response.type === "six_sense" && source === "activate") {
        this.props.trackAdoptionMetricsForPluginConnectedEvent('Six Sense');
      }
    })
    .catch(error => {
      console.error("Error activating account:", error);
    });
  };
  

  _handleCancelClick(){
    this.setState({
      apiKey : this.props.integration.configuration.apiKey
    });
  }

  _validateForm(){
    var errors = {};
    if(!this.state.apiKey || this.state.apiKey.trim() == ''){
      errors['apiKey'] = this.localizedSixSense.activate.error
    }

    return errors;
  }

  render(){
    return (
      <div className={styles.content}>
        <h1>{ this.localizedSixSense.activate.title }</h1>
        <p>{ this.localizedSixSense.activate.sub_text }</p>

        <p className={styles.errorMessage}>{this.props.error}</p>

        <div className={styles.form}>
          <InputField 
            className={styles.field} 
            title={`${this.localizedSixSense.activate.api_key}: `}
            placeholder={this.localizedSixSense.activate.placeholder}
            value = { this.state.apiKey }
            onChange={this._handleFieldChange.bind(this, 'apiKey')}
            errorMessage={this.state.errors['apiKey']}/>
            { !this.props.integration && 
              <button className={styles.button} onClick={() => {
                this._handleAuthenticationClick("activate")
              }}
               disabled={this.props.activating}>
                 {this.props.activating &&
                    `${this.localizedIntegrations.actions.activating}...`
                  }

                  {!this.props.activating &&
                    this.localizedIntegrations.actions.activate
                  }
              </button>
            }
            { this.props.integration && 
              <div className = {styles.alignment}>
                <button className={styles.button} onClick={() => {
                this._handleAuthenticationClick("save_changes")
              }} 
              disabled={this.props.activating}>
                {this.props.activating &&
                  `${this.localizedCommons.actions.saving_changes}...`
                }

                {!this.props.activating &&
                  this.localizedCommons.actions.save
                }
                </button>
                <button className={cx(styles.button, styles.cancel)} onClick = { this._handleCancelClick } >
                    { this.localizedCommons.actions.cancel }
                </button>
              </div>
            } 
        </div>
      </div>
    );
  }
}

export default SixSenseActivationView;